import { NavigationTabs, NavigationTabsItem, Stack } from '@sixfold/common-ui';
import React from 'react';
import { useMatch, useParams } from 'react-router';

import { Routes } from '../../routes';

export const RelationshipsTabs: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { company_id, slug_company_name } = useParams() as { company_id: string; slug_company_name?: string };
  const isCompanyGroup = useMatch(Routes.CompanyGroup.routerPath) !== null;

  return (
    <Stack direction="column" gap="medium">
      <NavigationTabs>
        <NavigationTabsItem
          href={Routes.CompanyRelationships.generatePath({ company_id, slug_company_name })}
          current={isCompanyGroup ? false : 'page'}>
          Relationships
        </NavigationTabsItem>
        <NavigationTabsItem
          href={Routes.CompanyGroup.generatePath({ company_id, slug_company_name })}
          current={isCompanyGroup ? 'page' : false}>
          Company group
        </NavigationTabsItem>
      </NavigationTabs>
      {children}
    </Stack>
  );
};
